export function writeToCookie(value: string, lifetime?: number): void {
    let dayInMilliSec: number = (1000*60*60*24);

    if (typeof lifetime !== 'undefined') {
        dayInMilliSec = lifetime * 30; // 30 days in milliseconds
    }
    const expirationTime: number = dayInMilliSec,
        date: Date = new Date;

    date.setTime(date.getTime() + expirationTime);
    const expireDate: string = date.toUTCString();

    let cookieValue = value + ";expires=" + expireDate + ";path=/;SameSite=Lax";

    if (location.hostname.startsWith('widget')) {
        // widget.journaway.com should be mapped to www.journaway.com
        const host = location.hostname.replace(/^(widget)\./i, 'www.');
        cookieValue += ";domain=" + host;
    }

    document.cookie = cookieValue;
}
